import { useReqMutation } from "../../../hooks/query";
import themeAPI from "../../../services/theme";

const useDeleteManySetupThemes = ({ onSuccess }) => {
  const mutation = useReqMutation(
    ids => {
      return themeAPI.deleteMany(ids);
    },
    {
      onSuccess: (data, variables) => {
        if (onSuccess) {
          onSuccess(data, variables);
        }
      }
    }
  );

  const deleteManySetupThemes = ids => mutation.mutate(ids);

  return {
    deleteManySetupThemes,
    isLoading: mutation.isLoading
  };
};

export default useDeleteManySetupThemes;
